import React from "react";
import { useLocation } from "react-router-dom";
import ReusableDemoPage from "../ReusableDemoPage";
import { rlthomeConfig, europeConfig } from "../demoConfigs";

const RLTHomeDemo = () => {
  const location = useLocation();

  // Use europeConfig for /demo/europe, otherwise use rlthomeConfig
  const config =
    location.pathname === "/demo/europe" ? europeConfig : rlthomeConfig;

  return <ReusableDemoPage config={config} />;
};

export default RLTHomeDemo;
